import styled, { css } from 'styled-components';

export const Container = styled.div`
  width: 100%;
  height: 40px;

  display: flex;
  align-items: stretch;
  column-gap: 24px;

  padding: 0 24px;

  background: ${({ theme }) => theme.colors.white};
  border-bottom: 1px solid ${({ theme }) => theme.colors.greys.lighty};
`;

export const Tab = styled.div`
  display: flex;
  align-items: center;

  cursor: pointer;

  font: ${({ theme, isSelected }) =>
    isSelected ? theme.fonts.textSmallWeight600 : theme.fonts.textSmall};
  color: ${({ theme, isSelected }) =>
    isSelected ? theme.colors.greys.darkest : theme.colors.greys.dark};

  transition: color 0.2s cubic-bezier(0, 0.64, 0.25, 0.99);

  &:hover {
    color: ${({ theme }) => theme.colors.greys.darkest};
  }

  // Keep the label vertically centered whatever the underline of the selected tab.
  border-top: 2px solid transparent;
  border-bottom: 2px solid transparent;

  ${({ isSelected, theme }) => {
    if (isSelected) {
      return css`
        border-bottom-color: ${theme.colors.brand.primary};
      `;
    }
  }}
`;
